import { collectionAlias, CollectionName } from "@tc/search-document-builders"

export enum SearchFieldId {
  CertificateType = "CertificateType",
  DestinationMarket = "DestinationMarket",
  Commodity = "Commodity",
  FieldId = "FieldId",
  CountryCode = "CountryCode",
  WineCategory = "WineCategory",
  DeAlcoholised = "DeAlcoholised",
  WineChemistryTest = "WineChemistryTest",
  Eligibility = "Eligibility",
  ProcessType = "ProcessType",
  BusinessArea = "BusinessArea",
  ImportCertificateType = "ImportCertificateType",
  Verifier = "verifiers",
  HsCode = "hs-codes",
  Package = "package-types",
  FreeSalePremise = "free-sale-premises",
  WineSpecialProcess = "wine-special-processes",
  WineGrapeVariety = "wine-grape-varieties",
  WineColor = "wine-colours",
  WineStyle = "wine-styles",
  WineIngredient = "eu-wine-ingredients",
  GeographicIndication = "wine-geographic-indications",
  UnLocode = "un-locode",
  Document = "document-types",
  CertificateDeliveryMethod = "certificate-delivery-methods",
  WSMPS = "wsmps",
  BottleSize = "bottle-sizes",
  EstarLaboratory = "estar-laboratories",
  Product = "products",
  ExportCertificate = "export-certificates",
  TransferRequests = "transfer-requests",
  TransferProducts = "transfer-products",
  OrganicPremise = "organic-premises",
  Templates = "templates",
  SupportingDocuments = "supporting-documents",
  // the name not yet finalized
  EstarWineTest = "estar-wine-test",
  Exporter = "exporters",
  CNCode = "cn-codes",
  BrazilWineClassification = "wine-br-classifications",
  Item = "item",
  CountryCodeV2 = "CountryCodeV2",
  Agency = "agency",
  Registration = "registrations",
  List = "list",
  OcaUsers = "oca-users",
}

export const SearchFieldCollectionMappings: Record<SearchFieldId, string> = {
  [SearchFieldId.CertificateType]: "public:certificate-types",
  [SearchFieldId.DestinationMarket]: collectionAlias(
    CollectionName.DestinationMarkets,
  ),
  [SearchFieldId.Commodity]: collectionAlias(CollectionName.CommodityTypes),
  [SearchFieldId.FieldId]: "ec:product-fields",
  [SearchFieldId.CountryCode]: collectionAlias(CollectionName.Countries),
  [SearchFieldId.WineCategory]: "ec:wine-eu-categories",
  [SearchFieldId.WineChemistryTest]: "ec:wine-chem-tests",
  [SearchFieldId.Eligibility]: "ec:eligibilities",
  [SearchFieldId.ProcessType]: "ec:process-types",
  [SearchFieldId.BusinessArea]: "public:business-areas",
  [SearchFieldId.ImportCertificateType]: "public:import-certificate-types",
  [SearchFieldId.Verifier]: "ec:verifiers",
  [SearchFieldId.HsCode]: "ec:hs-codes",
  [SearchFieldId.Package]: "public:package-types",
  [SearchFieldId.FreeSalePremise]: "ec:free-sale-premises",
  [SearchFieldId.WineSpecialProcess]: "ec:wine-special-processes",
  [SearchFieldId.WineGrapeVariety]: "ec:wine-grape-varieties",
  [SearchFieldId.WineColor]: "ec:wine-colours",
  [SearchFieldId.WineStyle]: "ec:wine-styles",
  [SearchFieldId.WineIngredient]: "ec:eu-wine-ingredients",
  [SearchFieldId.GeographicIndication]: "ec:wine-geographic-indications",
  [SearchFieldId.UnLocode]: "public:un-locode",
  [SearchFieldId.Document]: "ec:document-types",
  [SearchFieldId.CertificateDeliveryMethod]: "ec:certificate-delivery-methods",
  [SearchFieldId.WSMPS]: "ec:wsmps",
  [SearchFieldId.BottleSize]: "ec:bottle-sizes",
  [SearchFieldId.EstarLaboratory]: "ec:estar-laboratories",
  [SearchFieldId.EstarWineTest]: "ec:estar-wine-tests",
  [SearchFieldId.Product]: collectionAlias(CollectionName.Products),
  [SearchFieldId.ExportCertificate]: collectionAlias(
    CollectionName.ExportCertificates,
  ),
  [SearchFieldId.TransferRequests]: collectionAlias(
    CollectionName.TransferRequests,
  ),
  [SearchFieldId.TransferProducts]: collectionAlias(
    CollectionName.TransferProducts,
  ),
  [SearchFieldId.OrganicPremise]: "ec:organic-premises",
  [SearchFieldId.Exporter]: "private:exporters",
  [SearchFieldId.DeAlcoholised]: "ec:de-alcoholised",
  [SearchFieldId.CNCode]: "ec:cn-codes",
  [SearchFieldId.Templates]: collectionAlias(CollectionName.Templates),
  [SearchFieldId.SupportingDocuments]: collectionAlias(
    CollectionName.SupportingDocuments,
  ),
  [SearchFieldId.BrazilWineClassification]: "ec:wine-br-classifications",
  [SearchFieldId.Item]: collectionAlias(CollectionName.Item),
  [SearchFieldId.CountryCodeV2]: collectionAlias(CollectionName.Countries),
  [SearchFieldId.Agency]: collectionAlias(CollectionName.Agency),
  [SearchFieldId.Registration]: collectionAlias(CollectionName.Registrations),
  [SearchFieldId.List]: collectionAlias(CollectionName.List),
  [SearchFieldId.OcaUsers]: collectionAlias(CollectionName.OcaUsers),
}

export enum SearchFieldWsmpSubType {
  BottlerAndWinemaker = "Bottler & Winemaker",
  Winemaker = "Winemaker",
  Bottler = "Bottler",
}
